import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  iconName?: IconName;
  iconSize?: string;
  size?: 'small' | 'medium' | 'tiny';
};

const getSpinnerStyle = (size: string | null | undefined): string => {
  switch (size) {
    case 'small':
      return 'size-16';

    case 'tiny':
      return 'size-12';

    default:
      return 'size-150';
  }
};

export const Spinner = ({ className, iconName, iconSize = '5rem', size = 'medium' }: Props) => {
  const isSmall = size === 'small';
  return (
    <span
      className={classnames(
        'relative isolate inline-block text-black',
        getSpinnerStyle(size),
        className,
      )}
      data-testid="spinner"
    >
      <svg
        className={classnames(
          'direction-ltr animation-duration-infinite relative inline-block animate-spin leading-0',
        )}
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="fill-transparent"
          cx="33"
          cy="33"
          r="30"
          stroke={`url(#gradient--${size})`}
          style={{
            transform: 'scale(1.01)',
            transformOrigin: 'center',
            strokeDasharray: 168,
            strokeDashoffset: 20,
            strokeWidth: isSmall ? 7 : 2,
          }}
        />
        <linearGradient id={`gradient--${size}`}>
          <stop
            style={{
              stopColor: 'currentColor',
            }}
            offset="50%"
            stopOpacity="1"
          />
          <stop
            style={{
              stopColor: 'currentColor',
            }}
            offset="65%"
            stopOpacity=".5"
          />
          <stop
            style={{
              stopColor: 'currentColor',
            }}
            offset="100%"
            stopOpacity="0"
          />
        </linearGradient>
        <svg
          width="7px"
          height="7px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
          x="35"
          y=".5"
        >
          <circle className="fill-current" cx="33" cy="33" r="30" />
        </svg>
      </svg>
      {!!iconName && !isSmall && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Icon name={iconName} width={iconSize} />
        </span>
      )}
    </span>
  );
};
